import React from "react";
import { Outlet, Navigate } from "react-router-dom";

import App from "./../app.jsx";

import ExtraError from "./../pages/extra/extra-error.js";
import LoginV1 from "./../pages/user/login-v1.js";
import LoginV2 from "./../pages/user/login-v2.tsx";
import LoginV3 from "./../pages/user/login-v3.js";
import Logout from "./../pages/user/Logout.tsx";
import RegisterV3 from "./../pages/user/register-v3.js";
import HelperCSS from "./../pages/helper/helper-css.js";
import FormPreguntasInciales from "../pages/preguntas-iniciales/form.js";
import Confirmation from "../pages/preguntas-iniciales/confirmation.js";
import FormPostulante from "../pages/postulante/form.js";
import FormResult from "../pages/result/form.js";
import Solicitudes from "../pages/solicitudes/lista.js";
import TalentoHumano from "../pages/talento-humano/lista.js";
import Calendar from "../pages/calendar/calendar.js";
import LeaderCalendar from "../pages/calendar/LeaderCalendar.tsx";
import ListUsers from "../pages/user/ListUsers.tsx";
import ListRoles from "../pages/roles/ListRoles.tsx";
import NewRole from "../pages/roles/NewRole.tsx";
import RoleDetail from "../pages/roles/RoleDetail.tsx";
import AssignUserRoles from "../pages/roles/AssignUserRoles.tsx";
import Dashboard from "../pages/Dashboard.tsx";
import FormElements from "../pages/form/form-elements.js";
import FormPlugins from "../pages/form/form-plugins.js";
import NewUser from "../pages/user/NewUser.tsx";
import EditUser from "../pages/user/EditUser.tsx";
import Historial from "../pages/postulante/Historial.tsx";
import Print from "../pages/postulante/Print.tsx";
// import Catalog from "../pages/catalog/catalog.js";
import ListCatalog from "../pages/catalog/ListCatalog.tsx";
import FetchCollaborator from "../pages/postulante/FetchCollaborator.tsx";
import Vacantes from "../pages/vacantes/list.tsx";
import VacantesV2 from "../pages/vacantes/listV2.tsx";
import ListColaboradores from "../pages/colaboradores/ListColaboradores.tsx";
import ListListaNegra from "../pages/lista-negra/ListListaNegra.tsx";
import ListSolicitudes from "../pages/solicitudes/ListSolicitudes.tsx";
import CandidateTracking from "../pages/solicitudes/CandidateTracking.tsx";
import ProfilePartner from "../pages/profile-partner/ProfilePartner.tsx";
import Puestos from "../pages/puestos/Puestos.tsx";
import NewPosition from "../pages/puestos/NewPosition.tsx";
import EditPosition from "../pages/puestos/EditPosition.tsx";
import DocumentsReview from "../pages/documents/DocumentsReview.tsx";
import MyExpedient from "../pages/worker/MyExpedient.tsx";
import Tallas from "../pages/catalogo/Tallas.tsx";
import Catalogo from "../pages/catalogo/Catalogo.tsx";
import ImportPartners from "../pages/colaboradores/ImportPartners.tsx";
import ImportListaNegra from "../pages/lista-negra/ImportListaNegra.tsx";
import Reportes from "../pages/reports/ContractSignedReport.tsx";
import NewPlantilla from "../components/plantilla/NewPlantilla.tsx";
import Plantillas from "../pages/plantillas/Plantillas.tsx";
import Sucursales from "../pages/catalogo/Sucursales.tsx";
import SucursalesForm from "../components/catalogo/Sucursales/SucursalesForm.tsx";
import SucursalesHorio from "../components/catalogo/Sucursales/SucursalesHorio.tsx";
import SucursalesHorioDate from "../components/catalogo/Sucursales/SucursalesHorioDate.tsx";
import ReporteSucursal from "../components/catalogo/Sucursales/ReporteSucursal.tsx";
import RelojChecador from "../pages/reloj-checador/RelojChecador.tsx";
import ConfigPage from "../pages/config/ConfigPage.tsx";
import Assistances from "../components/catalogo/Sucursales/Assistances.tsx";
import ScheduleRealTimeComponent from "../components/catalogo/Sucursales/componentes/ScheduleRealTimeComponent.tsx";
import BirthDatesReport from "../components/catalogo/Sucursales/BirthDatesReport.tsx";
import BirthDatesReportGeneral from "../components/catalogo/Sucursales/BirthDatesReportGeneral.tsx";
import Traspasos from "../pages/traspasos/Traspasos.tsx";
import PartnersByBranch from "../components/catalogo/Sucursales/PartnersByBranch.tsx";
import ReportePlantilla from "../components/catalogo/Sucursales/ReportePlantilla.tsx";
import ResumenHorarios from "../components/catalogo/Sucursales/ResumenHorarios.tsx";
import ResumenHorariosAsistencia from "../components/catalogo/Sucursales/ResumenHorariosAsistencia.tsx";
import Entradas from "../pages/entradas/Entradas.tsx";
import CoberturaPuestos from "../components/catalogo/Sucursales/CoberturaPuestos.tsx";
import RiesgoOperativo from "../components/catalogo/Sucursales/riesgoOperativo/RiesgoOperativo.tsx";
import RiesgoOperativoPage from "../pages/riesgo-operativo/RiesgoOperativoPage.tsx";
import NewContract from "../pages/puestos/NewContract.tsx";
import Chequeo from "../components/catalogo/Sucursales/componentes/Chequeo.tsx";
import ChequeoCodigo from "../components/catalogo/Sucursales/componentes/ChequeoCodigo.tsx";
import DiasSinAsistencia from "../components/catalogo/Sucursales/componentes/DiasSinAsistencia.tsx";
import DiasDescanso from "../components/catalogo/Sucursales/componentes/DiasDescanso.tsx";
import Inasistencias from "../components/catalogo/Sucursales/inaisistencias/Inasistencias.tsx";
import Incidencias from "../components/catalogo/Sucursales/inciencias-legacy/Incidencias.tsx";
import NotificationsUsers from "../pages/notification-user/NotificationsUsers.tsx";
import NewNotification from "../pages/notification-user/components/NewNotification.tsx";
import EditNotification from "../pages/notification-user/components/EditNotification.tsx";
import MyNotifications from "../pages/my-notifications/MyNotifications.tsx";
import EditOrderPosition from "../components/config/EditOrderPosition.tsx";
import CelebrityDaysPage from "../pages/celebrity-days/CelebrityDaysPage.tsx";
import MandatoryDaysPage from "../pages/mandatory-days/MandatoryDaysPage.tsx";
import ReporteSolicitudes from "../pages/solicitudes/ReporteSolicitudes.tsx";
import Reports from "../pages/Reports.tsx";
import TemplateLeaders from "../pages/reports/TemplateLeaders.tsx";
import Badges from "../pages/badges/Badges.tsx";
import ApprovedIncapacity from "../pages/incapacities/ApprovedIncapacity.tsx";
import EditIncapacityPartner from "../pages/incapacities/EditIncapacityPartner.tsx";
import NewIncapacity from "../pages/incapacities/NewIncapacity.tsx";
import NewPermission from "../pages/permissions/NewPermission.tsx";
import ApprovedPermission from "../pages/permissions/ApprovedPermission.tsx";
import EditPermission from "../pages/permissions/EditPermission.tsx";
import ChilitosStats from "../pages/reports/ChilitosStats.tsx";
import DocumentsBranch from "../pages/reports/DocumentsBranch.tsx";
import DocumentsGraphs from "../pages/reports/DocumentsGraphs.tsx";
import Privacy from "../pages/Privacy.tsx";
import DobleFunctionReport from "../components/catalogo/Sucursales/DobleFunctionReport.tsx";
import DobleShiftReport from "../components/catalogo/Sucursales/DobleShiftReport.tsx";
import AllWeekReport from "../components/catalogo/Sucursales/AllWeekReport.tsx";
import SingleWorkDayReport from "../components/catalogo/Sucursales/SingleWorkDayReport.tsx";
import ReportDuplicateDevices from "../components/catalogo/Sucursales/componentes/ReportDuplicateDevices.tsx";
import Inassistence from "../components/catalogo/Sucursales/cubrirPuestos/Inassistence.tsx";
import BranchOrganigrama from "../components/catalogo/Sucursales/componentes/BranchOrganigrama.tsx";
import PageLeader from "../pages/leaderOfLeaders/PageLeader.tsx";
import NominaPage from "../pages/nomina/NominaPage.tsx";
import { NominaHistoryGuard } from "../components/nomina/NominaHistoryGuard.tsx";
import TableIncidents from "../components/incidents/TableIncidents.tsx";
import TableIncidentsDirectBoss from "../components/incidents/TableIncidentsDirectBoss.tsx";
import NominaDetalles from "../pages/nomina/NominaDetalles.tsx";
import BonosPage from "../pages/nomina/BonosPage.tsx";
import DeduccionesPage from "../pages/nomina/DeduccionesPage.tsx";
import TemplateListPage from "../pages/nomina/TemplateListPage.tsx";
import BonusTemplateListPage from "../pages/nomina/BonusTemplateListPage.tsx";
//import Test from "../pages/Test.tsx";
import AllPermissions from "../pages/permissions/AllPermissions.tsx";
import AuthorizedPermissions from "../pages/permissions/AuthorizedPermissions.tsx";
import AllMissingBox from "../pages/missing-box-partner/AllMissingBox.tsx";
import NewMissingBox from "../pages/missing-box-partner/NewMissingBox.tsx";
import EditMissingBox from "../pages/missing-box-partner/EditMissingBox.tsx";
import AllLoans from "../pages/loans/AllLoans.tsx";
import NewLoan from "../pages/loans/NewLoan.tsx";
import EditLoan from "../pages/loans/EditLoan.tsx";
import AllHolidays from "../pages/holidays/AllHolidays.tsx";
import ApprovedHoliday from "../pages/holidays/ApprovedHoliday.tsx";
import AllIncapacities from "../pages/incapacities/AllIncapacities.tsx";
import HolidayBalancesTable from "../pages/holidays/HollidaysTable.tsx";
import AllDirectBoss from "../pages/direct-boss/AllDirectBoss.tsx";
// import Test from "../pages/Test.tsx";
import EmailSettingsPage from "../pages/emails/EmailSettingsPage.tsx";
import EmailTemplatesPage from "../pages/emails/EmailTemplatesPage.tsx";
import EmailTemplateFormPage from "../pages/emails/EmailTemplateFormPage.tsx";
import CheckClarificationsPage from "../pages/check-clarifications/CheckClarificationsPage.tsx";
import FaqsPage from "../pages/faqs/FaqsPage.tsx";
import ListColaboradoresSuspendidos from "../pages/colaboradores-suspendidos/ListColaboradoresSuspendidos.tsx";
import ListControlBajas from "../pages/colaboradores-suspendidos/ListControlBajas.tsx";
import AllComplaints from "../pages/complaints/AllComplaints.tsx";
import NewComplaint from "../pages/complaints/NewComplaint.tsx";
import EditComplaint from "../pages/complaints/EditComplaint.tsx";
import ConfigHorarioSemanal from "../components/catalogo/Sucursales/config-horario-semanal/ConfigHorarioSemanal.tsx";
import TacticaOperativa from "../pages/tactica-operativa/TacticaOperativa.tsx";
import AusentismoPage from "../pages/tactica-operativa/ausentismo/AusentismoPage.tsx";
import PlantillaLideres from "../pages/tactica-operativa/lideres/PlantillaLideres.tsx";
import DocumentsTable from "../pages/documnets/DocumentsTable.tsx";

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "logout",
        element: <Logout />,
      },
      {
        path: "",
        element: <Dashboard />,
      },
      {
        path: "documents",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <DocumentsTable />,
            requiredPermission: "proceedings.view",
          },
        ],
      },
      {
        path: "emails",
        element: <Outlet />,
        children: [
          {
            path: "configuracion",
            element: <EmailSettingsPage />,
            requiredPermission: "emails.view",
          },
          {
            path: "plantillas",
            element: <EmailTemplatesPage />,
            requiredPermission: "emails.view",
          },
          {
            path: "plantillas/nuevo",
            element: <EmailTemplateFormPage />,
            requiredPermission: "emails.view",
          },
          {
            path: "plantillas/:id",
            element: <EmailTemplateFormPage />,
            requiredPermission: "emails.view",
          },
        ],
      },
      // {
      //   path: 'test',
      //   element: <Test />,
      //   roles: [
      //     "Administrador",]
      // },
      {
        path: "postulante",
        element: <Outlet />,
        children: [
          {
            path: "form",
            element: <FormPostulante />,
            requiredPermission: "applications.view",
          },
          {
            path: "historial/:curp",
            element: <Historial />,
            requiredPermission: "applications.view",
          },
        ],
      },
      {
        path: "birthdates",
        element: <BirthDatesReportGeneral />,
        requiredPermission: "reports.birthdates",
      },
      {
        path: "tactica-operativa",
        element: <TacticaOperativa />,
        requiredPermission: "tactical.view",
      },
      {
        path: "tactica-operativa/ausentismo",
        element: <AusentismoPage />,
        requiredPermission: "tactical.view",
      },
      {
        path: "tactica-operativa/lideres",
        element: <PlantillaLideres />,
        requiredPermission: "tactical.view",
      },
      {
        path: "reportes",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <Reports />,
            requiredPermission: "reports.view",
          },
          {
            path: "contratos-firmados",
            element: <Reportes />,
            requiredPermission: "contracts.view",
          },
          {
            path: "sucursales",
            element: <ReporteSolicitudes />,
            requiredPermission: "branches.view",
          },
          {
            path: "plantilla-lideres",
            element: <TemplateLeaders />,
            requiredPermission: "contracts.view",
          },
          {
            path: "estadisticas-chilito",
            element: <ChilitosStats />,
            requiredPermission: "reports.view",
          },
          {
            path: "documentos/:id",
            element: <DocumentsBranch />,
            requiredPermission: "proceedings.view",
          },
          // { path: "/cumpleaños", element: <Reportes />, roles: ["Administrador"] },
        ],
      },
      {
        path: "graficas",
        element: <DocumentsGraphs />,
        requiredPermission: "reports.view",
      },
      {
        path: "result",
        element: <Outlet />,
        children: [
          {
            path: "form",
            element: <FormResult />,
            requiredPermission: "files.upload",
          },
        ],
      },
      {
        path: "solicitudes/",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <ListSolicitudes />,
            requiredPermission: "applications.view",
          },
          {
            path: "tracking/:id",
            element: <CandidateTracking />,
            requiredPermission: "applications.view",
          },
          {
            path: "aprobar/:id",
            element: <FetchCollaborator />,
            requiredPermission: "applications.view",
          },
        ],
      },
      {
        path: "colaboradores/",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <ListColaboradores />,
            requiredPermission: "partners.view",
          },
          {
            path: "suspendidos",
            element: <ListColaboradoresSuspendidos />,
            requiredPermission: "partners.view",
          },
          {
            path: "control-bajas",
            element: <ListControlBajas />,
            requiredPermission: "partners.unsubscribe",
          },
          {
            path: "detalles/:id",
            element: <ProfilePartner />,
            requiredPermission: "partners.view",
          },
          {
            path: "aprobar-incapacidad/:id",
            element: <ApprovedIncapacity />,
            requiredPermission: "incapacities.view",
          },
          {
            path: "nueva-incapacidad/:id",
            element: <NewIncapacity />,
            requiredPermission: "incapacities.view",
          },
          {
            path: "nuevo-permiso/:id",
            element: <NewPermission />,
            requiredPermission: "labor_permissions.view",
          },
          {
            path: "aprobar-permiso/:id",
            element: <ApprovedPermission />,
            requiredPermission: "labor_permissions.view",
          },
          {
            path: "editar-permiso/:id",
            element: <EditPermission />,
            requiredPermission: "labor_permissions.view",
          },

          {
            path: "importar",
            element: <ImportPartners />,
            requiredPermission: "partners.view",
          },
        ],
      },
      {
        path: "revision-documentos",
        element: <DocumentsReview />,
        requiredPermission: "proceedings.view",
      },
      {
        path: "calendar",
        element: <Calendar />,
        requiredPermission: "applications.view",
      },
      {
        path: "leader-calendar",
        element: <LeaderCalendar />,
        requiredPermission: "applications.view",
      },
      {
        path: "catalog",
        element: <ListCatalog />,
        requiredPermission: "catalogs.view",
      },
      {
        path: "usuarios/",
        element: <Outlet />,
        children: [
          // Si no agregamos roles es poque solo es para admin
          {
            path: "",
            element: <ListUsers />,
            requiredPermission: "users.view",
          },
          { path: "nuevo", element: <NewUser />, requiredPermission: "users.create" },
          {
            path: "editar/:id",
            element: <EditUser />,
            requiredPermission: "users.view",
          },
        ],
      },
      {
        path: "roles",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <ListRoles />,
            requiredPermission: "roles.view",
          },
          {
            path: "nuevo",
            element: <NewRole />,
            requiredPermission: "roles.create",
          },
          {
            path: "usuarios",
            element: <AssignUserRoles />,
            requiredPermission: "users.assign_role",
          },
          {
            path: ":id",
            element: <RoleDetail />,
            requiredPermission: "roles.view",
          },
        ],
      },
      {
        path: "login",
        element: <Navigate to="/" />,
      },
      {
        path: "form",
        element: <Outlet />,
        children: [
          {
            path: "elements",
            element: <FormElements />,
            requiredPermission: "configuration.view",
          },
          {
            path: "plugins",
            element: <FormPlugins />,
            requiredPermission: "configuration.view",
          },
        ],
      },
      {
        path: "user",
        element: <Outlet />,
        children: [
          { path: "login-v1", element: <LoginV1 /> },
          { path: "login-v2", element: <LoginV2 /> },
          { path: "login-v3", element: <LoginV3 /> },
          { path: "register-v3", element: <RegisterV3 /> },
        ],
      },
      {
        path: "helper/css",
        element: <HelperCSS />,
      },
      {
        path: "vacantes",
        element: <Outlet />,
        children: [
          {
            path: "",
            // element: <Vacantes />,
            element: <VacantesV2 />,
            requiredPermission: "vacancies.view",
          },
        ],
      },
      {
        path: "lista-negra",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <ListListaNegra />,
            requiredPermission: "blacklists.view",
          },
          {
            path: "importar",
            element: <ImportListaNegra />,
            requiredPermission: "blacklists.view",
          },
        ],
      },
      {
        path: "mi-expediente",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <MyExpedient />,
            requiredPermission: "proceedings.view",
          },
          {
            path: "incapacidad/:id",
            element: <EditIncapacityPartner />,
            requiredPermission: "incapacities.view",
          },
          {
            path: "nuevo/:id",
            element: <NewIncapacity />,
            requiredPermission: "proceedings.view",
          },
        ],
      },
      {
        path: "insignias",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <Badges />,
            requiredPermission: "partners.view",
          },
        ],
      },
      {
        path: "puestos",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <Puestos />,
            requiredPermission: "positions.view",
          },
          {
            path: "nuevo",
            element: <NewPosition />,
            requiredPermission: "positions.view",
          },
          {
            path: "nuevo-contrato",
            element: <NewContract />,
            requiredPermission: "positions.view",
          },
          {
            path: "editar/:id",
            element: <EditPosition />,
            requiredPermission: "positions.view",
          },
        ],
      },
      {
        path: "plantillas",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <Plantillas />,
            requiredPermission: "contracts.view",
          },
          {
            path: "nuevo",
            element: <NewPlantilla />,
            requiredPermission: "contracts.view",
          },
          {
            path: "editar/:id",
            element: <NewPlantilla />,
            requiredPermission: "contracts.view",
          },
        ],
      },
      {
        path: "mis-notificaciones",
        element: <MyNotifications />,
      },
      {
        path: "notificaciones",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <NotificationsUsers />,
          },
          {
            path: "nueva-notificacion",
            element: <NewNotification />,
            requiredPermission: "notifications.manage",
          },
          {
            path: "editar/:id",
            element: <EditNotification />,
            requiredPermission: "notifications.manage",
          },
        ],
      },
      {
        path: "sucursales",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <Sucursales />,
            requiredPermission: "branches.view",
          },
          {
            path: "incidencias-legacy/:id",
            element: <Incidencias />,
            requiredPermission: "incidents.view",
          },
          {
            path: "incidencias/:id",
            element: <TableIncidents />,
            requiredPermission: "incidents.view",
          },
          {
            path: "chequeo",
            element: <Chequeo />,
            requiredPermission: "attendance.view",
          },
          {
            path: "incidencias",
            element: <TableIncidents />,
            requiredPermission: "incidents.view",
          },
          {
            path: "chequeo/:id",
            element: <Chequeo />,
            requiredPermission: "attendance.view",
          },
          {
            path: "reporte-codigo/:id",
            element: <ChequeoCodigo />,
            requiredPermission: "branches.view",
          },
          {
            path: "dias-sin-asistencia/:id",
            element: <DiasSinAsistencia />,
            requiredPermission: "attendance.view",
          },
          {
            path: "dias-descanso/:id",
            element: <DiasDescanso />,
            requiredPermission: "branches.view",
          },
          {
            path: "inasistencias",
            element: <Inasistencias />,
            requiredPermission: "attendance.view",
          },
          {
            path: "inasistencias/:id",
            element: <Inasistencias />,
            requiredPermission: "attendance.view",
          },
          {
            path: "nuevo",
            element: <SucursalesForm />,
            requiredPermission: "branches.view",
          },
          {
            path: "editar/:id",
            element: <SucursalesForm />,
            requiredPermission: "branches.view",
          },
          {
            path: "birthdates",
            element: <BirthDatesReportGeneral />,
            requiredPermission: "reports.birthdates",
          },
          {
            path: "birthdates/:id",
            element: <BirthDatesReport />,
            requiredPermission: "reports.birthdates",
          },
          {
            path: "colaboradores/:id",
            element: <PartnersByBranch />,
            requiredPermission: "partners.view",
          },
          {
            path: "horario/:id",
            element: <SucursalesHorio />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "horario-fecha/:id",
            element: <SucursalesHorioDate />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "reporte/:id",
            element: <ReporteSucursal />,
            requiredPermission: "branches.view",
          },
          {
            path: "reporte-plantilla/:id",
            element: <ReportePlantilla />,
            requiredPermission: "contracts.view",
          },
          {
            path: "cobertura-puestos/:id",
            element: <CoberturaPuestos />,
            requiredPermission: "positions.view",
          },
          {
            path: "riesgo-operativo/:id",
            element: <RiesgoOperativo />,
            requiredPermission: "attendance.view",
          },
          {
            path: "resumen-horario/:id",
            element: <ResumenHorarios />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "resumen-horario-asistencia/:id",
            element: <ResumenHorariosAsistencia />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "resumen-all-week/:id",
            element: <AllWeekReport />,
            requiredPermission: "branches.view",
          },
          {
            path: "resumen-doble-funcion/:id",
            element: <DobleFunctionReport />,
            requiredPermission: "branches.view",
          },
          {
            path: "resumen-duplicate-device/:id",
            element: <ReportDuplicateDevices />,
            requiredPermission: "branches.view",
          },
          {
            path: "organigrama-workers/:id",
            element: <BranchOrganigrama />,
            requiredPermission: "branches.view",
          },
          {
            path: "resumen-single-work/:id",
            element: <SingleWorkDayReport />,
            requiredPermission: "branches.view",
          },
          {
            path: "resumen-doble-turno/:id",
            element: <DobleShiftReport />,
            requiredPermission: "branches.view",
          },
          {
            path: "asistencias",
            element: <Assistances />,
            requiredPermission: "attendance.view",
          },
          {
            path: "asistencias/colaborador/:id",
            element: <Assistances />,
            requiredPermission: "attendance.view",
          },
          {
            path: "asistencias/:id/horario",
            element: <ScheduleRealTimeComponent />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "traspasos/:id",
            element: <Traspasos />,
            requiredPermission: "branches.view",
          },
          {
            path: "cubrir-puestos-urgente/:id",
            element: <Inassistence />,
            requiredPermission: "positions.view",
          },
          {
            path: "Aclaraciones-horario/:id",
            element: <CheckClarificationsPage />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "Aclaraciones-horario/:id/revisar/:clarificationId",
            element: <CheckClarificationsPage />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "config-horario-semanal/:id",
            element: <ConfigHorarioSemanal />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "config-horario-semanal",
            element: <ConfigHorarioSemanal />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "*",
            element: <ExtraError />,
          },
        ],
      },
      {
        path: "riesgo-operativo",
        element: <RiesgoOperativoPage />,
        requiredPermission: "attendance.view",
      },
      {
        path: "sucursal",
        element: <Outlet />,
        children: [
          {
            path: "colaboradores",
            element: <PartnersByBranch />,
            requiredPermission: "partners.view",
          },
          {
            path: "birthdates",
            element: <BirthDatesReport />,
            requiredPermission: "reports.birthdates",
          },
          {
            path: "horario",
            element: <SucursalesHorio />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "horario-fecha",
            element: <SucursalesHorioDate />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "reporte",
            element: <ReporteSucursal />,
            requiredPermission: "branches.view",
          },
          {
            path: "reporte-plantilla",
            element: <ReportePlantilla />,
            requiredPermission: "contracts.view",
          },
          {
            path: "resumen-horario",
            element: <ResumenHorarios />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "resumen-horario-asistencia",
            element: <ResumenHorariosAsistencia />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "asistencias",
            element: <Assistances />,
            requiredPermission: "attendance.view",
          },
          {
            path: "asistencias/colaborador/:id",
            element: <Assistances />,
            requiredPermission: "attendance.view",
          },
          {
            path: "asistencias/:id/horario",
            element: <ScheduleRealTimeComponent />,
            requiredPermission: "attendance.configure_schedule",
          },
          {
            path: "traspasos",
            element: <Traspasos />,
            requiredPermission: "branches.view",
          },
          {
            path: "incidencias",
            element: <TableIncidents />,
            requiredPermission: "incidents.view",
          },
          {
            path: "reporte-reloj",
            element: <Chequeo />,
            requiredPermission: "attendance.view",
          },
          {
            path: "dias-sin-asistencia",
            element: <DiasSinAsistencia />,
            requiredPermission: "attendance.view",
          },
          {
            path: "dias-descanso",
            element: <DiasDescanso />,
            requiredPermission: "branches.view",
          },
        ],
      },
      {
        path: "reloj-checador",
        element: <RelojChecador />,
        requiredPermission: "attendance.check",
      },
      {
        path: "configuracion",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <ConfigPage />,
            requiredPermission: "configuration.view",
          },
          {
            path: "order-puestos",
            element: <EditOrderPosition />,
            requiredPermission: "positions.view",
          },
          {
            path: "dias-festivos",
            element: <CelebrityDaysPage />,
            requiredPermission: "configuration.view",
          },
          {
            path: "dias-obligatorios",
            element: <MandatoryDaysPage />,
            requiredPermission: "configuration.view",
          },
          {
            path: "faqs",
            element: <FaqsPage />,
            requiredPermission: "configuration.view",
          },
        ],
      },
      {
        path: "registro-de-entradas",
        element: <Entradas />,
        children: [
          {
            path: "",
            element: <ConfigPage />,
            requiredPermission: "attendance.view",
          },
        ],
      },
      {
        path: "nomina",
        element: <NominaHistoryGuard />,
        children: [
          {
            path: "",
            element: <NominaPage />,
            requiredPermission: "payroll.view",
          },
          {
            path: "detalles",
            element: <NominaDetalles />,
            requiredPermission: "payroll.view",
          },
          {
            path: "bonos",
            element: <BonosPage />,
            requiredPermission: "perceptions.view",
          },
          {
            path: "deducciones",
            element: <DeduccionesPage />,
            requiredPermission: "deductions.view",
          },
          {
            path: "plantillas",
            element: <TemplateListPage />,
            requiredPermission: "payroll.view",
          },
          {
            path: "plantillas-bonos",
            element: <BonusTemplateListPage />,
            requiredPermission: "perceptions.view",
          },
        ],
      },
      {
        path: "direct-boss",
        element: <AllDirectBoss />,
        requiredPermission: "direct_boss.manage",
      },
      {
        path: "permisos",
        element: <AllPermissions />,
        requiredPermission: "labor_permissions.view",
      },
      {
        path: "permisos/autorizados",
        element: <AuthorizedPermissions />,
        requiredPermission: "labor_permissions.view",
      },
      {
        path: "permisos/:bossId",
        element: <AllPermissions />,
        requiredPermission: "labor_permissions.view",
      },
      {
        path: "vacaciones",
        element: <AllHolidays />,
        requiredPermission: "holidays.view",
      },
      {
        path: "vacaciones/:bossId",
        element: <AllHolidays />,
        requiredPermission: "holidays.view",
      },
      {
        path: "vacaciones-tabla",
        element: <HolidayBalancesTable />,
        requiredPermission: "holidays.view",
      },
      {
        path: "vacaciones-tabla/:bossId",
        element: <HolidayBalancesTable />,
        requiredPermission: "holidays.view",
      },
      {
        path: "colaboradores/aprobar-vacaciones/:id",
        element: <ApprovedHoliday />,
        requiredPermission: "holidays.view",
      },
      {
        path: "incapacidades",
        element: <AllIncapacities />,
        requiredPermission: "incapacities.view",
      },
      {
        path: "incapacidades/:bossId",
        element: <AllIncapacities />,
        requiredPermission: "incapacities.view",
      },
      {
        path: "incidencias",
        element: <TableIncidents />,
        requiredPermission: "incidents.view",
      },
      {
        path: "incidencias/:bossId",
        element: <TableIncidentsDirectBoss />,
        requiredPermission: "incidents.view",
      },
      {
        path: "colaboradores/aprobar-incapacidad/:id",
        element: <ApprovedIncapacity />,
        requiredPermission: "incapacities.view",
      },
      {
        path: "faltantes-caja",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <AllMissingBox />,
            requiredPermission: "missing_box.view",
          },
          {
            path: "nuevo",
            element: <NewMissingBox />,
            requiredPermission: "missing_box.view",
          },
          {
            path: "editar/:id",
            element: <EditMissingBox />,
            requiredPermission: "missing_box.view",
          },
        ],
      },
      {
        path: "prestamos",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <AllLoans />,
            requiredPermission: "loans.view",
          },
          {
            path: "nuevo",
            element: <NewLoan />,
            requiredPermission: "loans.view",
          },
          {
            path: "editar/:id",
            element: <EditLoan />,
            requiredPermission: "loans.view",
          },
        ],
      },
      {
        path: "quejas",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <AllComplaints />,
            requiredPermission: "complaints.view",
          },
          {
            path: "nuevo",
            element: <NewComplaint />,
            requiredPermission: "complaints.view",
          },
          {
            path: "editar/:id",
            element: <EditComplaint />,
            requiredPermission: "complaints.view",
          },
        ],
      },
      {
        path: "*",
        element: <ExtraError />,
      },
    ],
  },
];

export const PublicRoutes = [
  {
    path: "politica-de-privacidad",
    element: <Privacy />,
  },
  {
    path: "logout",
    element: <Logout />,
  },
  {
    path: "login",
    element: <LoginV2 />,
  },
  {
    path: "unete",
    element: <Outlet />,
    children: [{ path: "", element: <LoginV3 /> }],
  },
  {
    path: "preguntas-iniciales",
    element: <Outlet />,
    children: [
      { path: "form", element: <FormPreguntasInciales /> },
      { path: "confirmation", element: <Confirmation /> },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/unete" />,
  },
];

export default AppRoute;
